import React from 'react';
import { useDarkMode } from './hooks/useDarkMode';

// Data
import personalData from './data/personal.json';
import skillsData from './data/skills.json';
import projectsData from './data/projects.json';
import experienceData from './data/experience.json';
import educationData from './data/education.json';
import certificatesData from './data/certificates.json';

// Components
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Certificates from './components/Certificates';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  const [isDark, setIsDark] = useDarkMode();

  return (
    <div className="min-h-screen bg-[#F5F2E8] dark:bg-gray-900 transition-colors duration-300">
      <Navbar isDark={isDark} toggleDark={() => setIsDark(!isDark)} />

      <main>
        <Hero data={personalData} />
        <About data={personalData} />
        <Skills skills={skillsData} />
        <Projects projects={projectsData} />
        <Experience
          experience={experienceData}
          education={educationData}
        />
        <Certificates certificates={certificatesData} />
        <Contact data={personalData} />
      </main>

      <Footer data={personalData} />
    </div>
  );
}

export default App;